export default "__VITE_PUBLIC_ASSET__273d984f__"